import { render } from "./AdminStartHub.vue?vue&type=template&id=22ecc15c"
import script from "./AdminStartHub.vue?vue&type=script&lang=js"
export * from "./AdminStartHub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__